// ** Components
import Section from '@/components/common/Section';
import BildTextSimpleBlock from './SimpleBlock';
import BildTextDesignBlock from './DesignBlock';

// ** Types
import type { StrapiComponentProps } from '@/types/strapi';
import type { ComponentBlocksBildTextBlock as BildTextBlockProps } from '@/types/graphql';

type ComponentBlocksBildTextBlockProps = StrapiComponentProps<BildTextBlockProps>;
type ComponentElementBildTextProps = StrapiComponentProps<Omit<BildTextBlockProps, 'bildTextVariant'>>;

const ComponentBlocksBildTextBlock = ({
	maxWidthPx,
	containerSx,
	bildTextVariant,
	...props
}: ComponentBlocksBildTextBlockProps) => {
	const variantComponents: Record<string, React.ComponentType<ComponentElementBildTextProps>> = {
		design: BildTextDesignBlock,
		simple: BildTextSimpleBlock
	};

	const variantKey = bildTextVariant?.toLowerCase() || 'simple';
	const SelectedVariant = variantComponents[variantKey] || BildTextSimpleBlock;

	// The design variant is full-bleed and manages its own gutters + viewport-based
	// background math, so it must not get the Section's max-width cap and page padding.
	const isDesignVariant = variantKey === 'design';

	return (
		<Section maxWidthPx={maxWidthPx} containerSx={containerSx} fullWidth={isDesignVariant}>
			<SelectedVariant {...props} />
		</Section>
	);
};

export default ComponentBlocksBildTextBlock;
